<template>
  <div class="cl-page">

    <!-- Hero -->
    <div class="cl-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-file-sign</v-icon>
        </v-avatar>
        <div>
          <div class="cl-hero__title">Búsqueda de contratos generados</div>
          <div class="cl-hero__sub">Consulta, descarga y gestión de contratos por estudiante</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-school-outline</v-icon> Académico
      </v-chip>
    </div>

    <div class="cl-body">

      <!-- Búsqueda -->
      <v-card outlined class="cl-filters-card mb-4">
        <v-card-title class="cl-filters-card__title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-account-search-outline</v-icon>
          Buscar estudiante
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="5">
              <v-combobox
                v-model="filtroestudiante"
                :items="estudiantes"
                label="Carnet del estudiante"
                :loading="isloadingestudent"
                loader-height="6"
                placeholder="Tecla enter para buscar..."
                hide-details outlined dense
                prepend-inner-icon="mdi-card-account-details-outline"
              />
            </v-col>
            <v-col cols="12" sm="7" class="d-flex align-center" style="gap:8px;">
              <v-chip x-small :color="contratos.length ? 'indigo lighten-5' : 'grey lighten-3'"
                class="indigo--text text--darken-2 font-weight-medium">
                {{ contratos.length }} contrato{{ contratos.length !== 1 ? 's' : '' }}
              </v-chip>
              <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" />
            </v-col>
          </v-row>
          <v-alert v-if="msg" dense text type="error" class="mt-3 mb-0" style="font-size:0.85rem;">
            {{ msg }}
          </v-alert>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="cl-table-card">
        <v-data-table
          :headers="headers"
          :items="contratos"
          :loading="loading"
          loading-text="Buscando contratos..."
          no-data-text="Busque un estudiante para ver sus contratos."
          dense
          class="cl-table"
        >
          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex align-center" style="gap:4px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="indigo darken-1" v-on="on" @click="vercontrato(item)">
                    <v-icon x-small>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="orange darken-1" :disabled="item.loading" v-on="on" @click="descargarcontrato(item)">
                    <v-icon x-small>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Descargar contrato</span>
              </v-tooltip>

              <v-tooltip bottom v-if="$store.state.CARGO.id == 14 || $store.state.CARGO.id == 1">
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="red darken-1" v-on="on" @click="aniquilarcontrato(item)">
                    <v-icon x-small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar contrato</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <!-- Dialog detalle -->
    <v-dialog v-model="dialog" max-width="720">
      <v-card class="cl-detail-card">
        <div class="cl-detail-header px-5 py-3 d-flex align-center justify-space-between">
          <span class="white--text font-weight-bold" style="font-size:0.95rem;">
            <v-icon color="white" small class="mr-1">mdi-file-sign</v-icon>
            Información del contrato
          </span>
          <v-btn icon dark small @click="dialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider />

        <v-card-text class="pa-4">
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="cl-section-label mb-2">Participante</div>
              <div class="cl-drow"><span class="cl-dk">Nombre</span><span class="cl-dv">{{ item.participante }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Carnet</span><span class="cl-dv">{{ item.participante_ci }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Domicilio</span><span class="cl-dv">{{ item.participante_domicilio }}</span></div>
              <div class="cl-drow"><span class="cl-dk">ID</span><span class="cl-dv">{{ item.participante_id }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Nacionalidad</span><span class="cl-dv">{{ item.participante_nacionalidad }}</span></div>

              <div class="cl-section-label mt-3 mb-2">Programa</div>
              <div class="cl-drow"><span class="cl-dk">Nombre</span><span class="cl-dv">{{ item.programa_nombre }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Tipo</span><span class="cl-dv">{{ item.programa_tipo }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Carga horaria</span><span class="cl-dv">{{ item.programa_carga_horario }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Matrícula</span><span class="cl-dv">{{ item.programa_matricula_monto }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Colegiatura</span><span class="cl-dv">{{ item.programa_colegiatura_monto }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Sede</span><span class="cl-dv">{{ item.ciudad }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Dirección</span><span class="cl-dv">{{ item.direccion }}</span></div>
            </v-col>

            <v-col cols="12" sm="6">
              <div class="cl-section-label mb-2">Representante</div>
              <div class="cl-drow"><span class="cl-dk">Nombre</span><span class="cl-dv">{{ item.representante }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Carnet</span><span class="cl-dv">{{ item.representante_ci }}</span></div>
              <div class="cl-drow"><span class="cl-dk">Expedido</span><span class="cl-dv">{{ item.representante_expedido }}</span></div>

              <div class="cl-section-label mt-3 mb-2">Registro</div>
              <div class="cl-drow"><span class="cl-dk">Fecha registro</span><span class="cl-dv">{{ item.fecha_registro }}</span></div>
            </v-col>
          </v-row>

          <v-divider class="my-3" />
          <div class="cl-section-label mb-2">Módulos del programa</div>
          <v-data-table :headers="headersmodulos" :items="item.modulos" dense hide-default-footer class="cl-inner-table" />

          <v-divider class="my-3" />
          <div class="cl-section-label mb-2">Plan de pagos del estudiante</div>
          <v-data-table :headers="headersplan" :items="item.plan_pagos" dense hide-default-footer class="cl-inner-table" />
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="indigo darken-1" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="false">
      <ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" />
    </div>
  </div>
</template>

<script>
  import ABuscarPersona from '@/components/ABuscarPersona';
  import xaxios from '@/xaxios';

  export default {
    components: { ABuscarPersona },
    data() {
      return {
        msg: '',
        timeoutHnd: 0,
        filtroestudiante: null,
        isloadingestudent: false,
        loading: false,
        estudiantes: [],
        headers: [
          { text: 'Participante',   value: 'participante' },
          { text: 'Programa',       value: 'programa_nombre' },
          { text: 'Domicilio',      value: 'participante_domicilio' },
          { text: 'Fecha registro', value: 'fecha_registro',  width: '150' },
          { text: 'Opciones',       value: 'opciones',        width: '100', sortable: false },
        ],
        headersmodulos: [
          { text: 'Mod #',  value: 'numero' },
          { text: 'Módulo', value: 'modulo' },
        ],
        headersplan: [
          { text: 'Cuota',      value: 'nro_cuota' },
          { text: 'Concepto',   value: 'concepto_pago' },
          { text: 'Monto',      value: 'monto' },
          { text: 'Fecha pago', value: 'fecha_pago' },
        ],
        contratos: [],
        dialog: false,
        item: {},
      };
    },
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      resultadobusquedaest() {},
      getDatos() {
        window.console.log(this.filtroestudiante);
        this.loading = true;
        const vue = this;
        let persona_id = this.filtroestudiante.id;
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${persona_id}/persona`;
        const promise3 = xaxios.get(url3);

        Promise.all([promise3])
          .then(function(values) {
            let data = values[0].data;
            if (!data) {
              vue.msg = 'No se han encontrado contratos.';
            } else {
              data.data.map((x) => { x.loading = false; });
              vue.contratos = data.data;
            }
            window.console.log('estudiante::', data);
            vue.loading = false;
          })
          .catch((e) => {
            vue.$emit('dataloaded');
            window.console.error(e);
            vue.loading = false;
          });
      },
      vercontrato(item) {
        this.item = item;
        this.dialog = true;
      },
      descargarcontrato(item) {
        this.loading = true;
        item.loading = true;
        const vue = this;
        let contrato_id = item.id;
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${contrato_id}/pdf`;
        xaxios
          .get(url3)
          .then((x) => {
            let datapdf = x.data.data;
            const downloadLink = document.createElement('a');
            downloadLink.href = datapdf;
            downloadLink.download = 'Contrato-' + item.participante + '.pdf';
            downloadLink.click();
            vue.loading = false;
            item.loading = false;
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
            item.loading = false;
          });
      },
      aniquilarcontrato(item) {
        window.console.log(item);
        const vue = this;
        var message = {
          title: 'Confirme que desea eliminar este contrato',
          body: '<br> <b>NOTA:</b> Esta accion elimina el contrato permitiendo generar otro de nuevo.<br/>Use esta opcion solo cuando algun dato del contrato desea cambiarse.',
        };
        var options = {
          html: true,
          okText: 'Eliminar contrato',
          cancelText: 'Cancelar',
          reverse: true,
          type: 'hard',
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para proceder.',
          loader: true,
        };
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            vue.loading = true;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${item.id}`;
            xaxios
              .delete(url)
              .then((x) => {
                window.console.log(x);
                let res = x.data.data;
                vue.msg = res;
                vue.loading = false;
                vue.contratos = vue.contratos.filter((x) => x.id != item.id);
                dialog.close();
              })
              .catch((e) => {
                window.console.error(e);
                vue.loading = false;
              });
          })
          .catch(function() {});
      },
    },
  };
</script>

<style scoped>
.cl-page { min-height: 100vh; background: #f5f7fa; }

.cl-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.cl-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.cl-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.cl-body { padding: 20px 24px; }

.cl-filters-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.cl-filters-card__title {
  font-size: 0.8rem !important; font-weight: 700 !important;
  color: #283593; letter-spacing: 0.02em; border-bottom: 1px solid #e8edf7;
}

.cl-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.cl-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.cl-table >>> tbody tr:hover { background: #f0f4ff !important; }
.cl-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 12px !important;
}

.cl-detail-card { border-radius: 10px !important; overflow: hidden; }
.cl-detail-header {
  background: linear-gradient(120deg, #1a237e 0%, #283593 100%);
}

.cl-section-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #1a237e;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid #e8edf7;
  padding-bottom: 4px;
}

.cl-drow {
  display: flex;
  gap: 6px;
  margin-bottom: 3px;
  font-size: 0.8rem;
  line-height: 1.4;
}
.cl-dk {
  color: #78909c;
  min-width: 100px;
  flex-shrink: 0;
}
.cl-dv {
  color: #263238;
  font-weight: 500;
  word-break: break-word;
}

.cl-inner-table >>> thead tr th {
  background: #f5f7fa !important;
  color: #455a64 !important;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  padding: 4px 10px !important;
}
.cl-inner-table >>> tbody tr td {
  font-size: 0.78rem;
  padding: 3px 10px !important;
}
</style>
